import { useEffect, useState } from 'react';
import { useUIStore } from '@/state/store';

export function PreNotification() {
  const view = useUIStore((s) => s.view);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (view !== 'dashboard') {
      setShow(false);
      return;
    }
    const t = setTimeout(() => setShow(true), 3000);
    const t2 = setTimeout(() => setShow(false), 9000);
    return () => {
      clearTimeout(t);
      clearTimeout(t2);
    };
  }, [view]);

  if (!show) return null;

  return (
    <div className="prenotif show">
      <div className="pn-dot"></div>
      <div className="pn-text">
        <strong>Du erhältst den nächsten Call</strong>
        <br />
        Privatkunden · Position 1 von 4
      </div>
    </div>
  );
}
